import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Loader from "../Loading/loading";

//import user from "../../static/images/user_default.png";
import defaultLogo from "../../static/images/rsz_real-estate-building-logo-icon-vector.jpg";
function CarouselVacantes({ id, isMobile }) {
  const [Courses, setVacantes] = useState([]);
  const [indicators, setindicators] = useState([]);
  const [items, setitems] = useState([]);
  const [loading, setloading] = useState(true);
  const qty = isMobile ? 1 : 3;
  let history = useHistory();

  useEffect(() => {
    Carouselinner();
  }, []);

  function Carouselinner() {
    axios.get("company-vacant/list").then((result) => {
      setVacantes(result.data);
      LoadData(result.data);
    });
  }

  function LoadData(data) {
    let indice = 0;
    let step = qty;
    let arrItems = [];

    for (let index = 0; index <= data.length - 1; index) {
      let arr = data.slice(index, step);
      let carItem = (
        <div
          key={Math.floor(Math.random() * 1000)}
          data-bs-interval="1000000"
          className={index == 0 ? "carousel-item active" : "carousel-item"}
          style={{ height: "100%" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "normal",
              justifyContent: "space-around",
              height: "100%",
              width: "100%",
            }}
          >
            {arr.map((item) => {
              return (
                <div
                  key={item.vacantDTOResponse.companyVacantId}
                  style={{
                    flexBasis: isMobile ? "50%" : "23%",
                    MinHeight: "90%",
                    height: "90%",
                    maxHeight: "90%",
                    padding: "2px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      outline: "1px solid #dbdbdb",
                      borderRadius: "25px",
                      height: "100%",
                      marginBottom: "17px",
                      overflow: "hidden",
                      padding: "28px 14px 20px",
                      background: "rgb(255, 255, 255)",
                    }}
                  >
                    <div className="card-logo border-gray">
                      <img
                        loading="lazy"
                        style={{ width: "100%", height: "100%" }}
                        src={
                          item.vacantDTOResponse.fotoPerfilEmpresa
                            ? item.vacantDTOResponse.fotoPerfilEmpresa
                            : defaultLogo
                        }
                      ></img>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "60%",
                        borderRadius: "0 0 25px 25px",
                        justifyContent: "space-between",
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          color: "#696969",
                          fontWeight: "600",
                          fontSize: "0.9rem",
                          background: "#0000",
                        }}
                      >
                        {item.vacantDTOResponse.name}
                      </p>
                      <p
                        style={{
                          color: "#888888",
                          fontWeight: "300",
                          fontSize: "0.75rem",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.vacantDTOResponse.cargo}
                      </p>
                      <button
                        onClick={() => {
                          Goto(item.vacantDTOResponse.companyVacantId);
                        }}
                        className="btn-deg"
                      >
                        Ver
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );

      if (step + parseInt(qty) <= data.length) {
        index = step + 1;
        step += parseInt(qty) + 1;
      } else {
        index = step + 1;
        step = data.length;
      }
      indice++;
      arrItems.push(carItem);
    }

    setitems(arrItems);
    LoadIndicators(indice - 1);
    setloading(false);
  }

  function LoadIndicators(data) {
    let arr = [];

    for (let index = 0; index <= data; index++) {
      let btn = (
        <button
          key={index}
          type="button"
          data-bs-target={"#carousel" + id}
          data-bs-slide-to={"" + index + ""}
          aria-label={"Slide " + (index + 1)}
          className={index == 0 ? "active" : ""}
        ></button>
      );
      arr.push(btn);
    }
    setindicators(arr);
  }

  function Goto(id) {
    history.push({
      pathname: "/user/Vacante/" + id,
    });
  }

  return (
    <div
      id={"carousel" + id}
      className={loading ? "loader_container" : "carousel slide"}
      data-interval="false"
      style={{ height: "300px", display: "flex", flexDirection: "column" }}
    >
      {loading ? (
        <Loader type="small"></Loader>
      ) : (
        <Fragment>
          <div
            className="carousel-inner"
            style={{ flexBasis: "100%", minHeight: "100%" }}
          >
            {items}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="prev"
          ></button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="next"
          ></button>
        </Fragment>
      )}
    </div>
  );
}

export default CarouselVacantes;
